import React, { useState, useEffect } from "react";
import CustomerForm from "./CustomerForm";
import { Column, Row } from "simple-flexbox";
import {
  Paper,
  makeStyles,
  TableBody,
  TableRow,
  TableCell,
  Toolbar,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../../../utilities/useTable";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import Controls from "../../../controls/Controls";
import { Search } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import Popup from "../../../utilities/Popup";
import ViewIcon from "@material-ui/icons/RemoveRedEye";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import Notification from "../../../utilities/Notification";
import ConfirmDialog from "../../../utilities/ConfirmDialog";
import AddCustomer from "./AddCustomerInfo";
import { store } from "../../../../redux-store/store";

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(1),
    padding: theme.spacing(3),
  },
  searchInput: {
    width: "25%",
  },
  newButton: {
    position: "absolute",
    right: "10px",
  },
}));

const headCells = [
  { id: "customerName", label: "Customer Name" },
  { id: "customerAddress", label: "Zip Code" },
  { id: "cutomerCity", label: "Country" },
  { id: "cutomerphone", label: "State" },
  { id: "cutomtterphone", label: "Address" },
  { id: "creditCustomer", label: "Credit Customer" },
  { id: "creditApproved", label: "Credit Approved" },
  { id: "actions", label: "Actions" },
];

export function Locations({ states, customer, AddLocation, ApproveCustomerCredit }) {
  const classes = useStyles();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [addOpenPopup, setAddOpenPopup] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(customer, headCells, filterFn);
  useEffect(() => {
    store.dispatch({ type: "LOAD_CUSTOMER_INFO" });
    return () => {};
  }, []);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) =>
            x.locationName.toLowerCase().includes(target.value)
          );
      },
    });
  };

  const addOrEdit = (Location, resetForm) => {
    if (Location.id === 0) AddLocation(Location);
    else
      var data = {
        ...Location,
        companyId: store.getState().persistReducer.companyId,
      };
    store.dispatch({ type: "UPDATE_LOCATION", payload: data });
    resetForm();
    // setRecordForEdit(null)
    setOpenPopup(false);
    setAddOpenPopup(false);
  };

  const addCustomerInfo = (customer, resetForm) => {
    store.dispatch({ type: "ADD_CUTSTOMER_INFO", payload: customer });
    resetForm();
    setRecordForEdit(null);
    setAddOpenPopup(false);
    setOpenPopup(false);
  };

  const openInPopup = (item) => {
    setRecordForEdit(item);
    setOpenPopup(true);
  };
  const onApprove = (id) => {
    store.dispatch({ type: "APPROVE_CUSTOMER", payload: id });
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
  };
  return (
    <>
      <div
        className="container"
        style={{ paddingTop: "40px", marginTop: "-5rem" }}
      >
        <div>
          <Column flexGrow={1}>
            <ToastContainer />
            <div className="mt-4" style={{ position: "relative" }}>
              <Controls.Input
                // label="Search Locations by Location Name"
                placeholder="Search Locations by Location Name"
                className={classes.searchInput}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
                onChange={handleSearch}
              />
            </div>
            <Paper className={classes.pageContent}>
              <h4>
                {" "}
                <strong>Customers </strong>
              </h4>
              <Toolbar>
                <Controls.Button
                  text="Add New Customer"
                  variant="outlined"
                  startIcon={<AddIcon />}
                  className={classes.newButton}
                  onClick={() => {
                    setAddOpenPopup(true);
                    setRecordForEdit(null);
                  }}
                />
              </Toolbar>
              <TblContainer>
                <TblHead />
                <TableBody>
                  {recordsAfterPagingAndSorting().map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.name}</TableCell>
                      <TableCell>{item.zipCode}</TableCell>
                      <TableCell>{item.country}</TableCell>{" "}
                      <TableCell>{item.state}</TableCell>
                      <TableCell>{item.address}</TableCell>
                      <TableCell>{item.creditCustomer.toString()}</TableCell>
                      <TableCell>{item.creditApproved.toString()}</TableCell>
                      <TableCell>
                        <Controls.ActionButton
                          color="primary"
                          onClick={() => {
                            openInPopup(item);
                          }}
                        >
                          <ViewIcon fontSize="small" />
                        </Controls.ActionButton>
                        <Controls.ActionButton
                          color="primary"
                          onClick={() => {
                            setConfirmDialog({
                              isOpen: true,
                              title:
                                "You're about to approve this customer credit",
                              subTitle: "You can't undo this operation",
                              onConfirm: () => {
                                onApprove(item.id);
                              },
                            });
                          }}
                        >
                          <VerifiedUserIcon fontSize="small" />
                        </Controls.ActionButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </Paper>
            <Popup
              title="View Customer Info"
              openPopup={openPopup}
              setOpenPopup={setOpenPopup}
            >
              <CustomerForm
                recordForEdit={recordForEdit}
                addOrEdit={addOrEdit}
                states={states}
                countries={store.getState().locationReducer.countries}
                locationTypes={store.getState().locationReducer.locationTypes}
              />
            </Popup>

            <Popup
              title="Add Customer Form"
              openPopup={addOpenPopup}
              setOpenPopup={setAddOpenPopup}
            >
              <AddCustomer
                recordForEdit={recordForEdit}
                addCustomerInfo={addCustomerInfo}
                companyLocations={store.getState().userReducer.companyLocations}
                userLocations={store.getState().userReducer.userLocations}
                cacNumber={store.getState().userReducer.cacNumber}
                states={states}
                countries={store.getState().locationReducer.countries}
                locationTypes={store.getState().locationReducer.locationTypes}
              />
            </Popup>
            <Notification notify={notify} setNotify={setNotify} />
            <ConfirmDialog
              confirmDialog={confirmDialog}
              setConfirmDialog={setConfirmDialog}
            />
          </Column>
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    buttonloader: state.utilityReducer.buttonloader,
    user: state.userReducer.user,
    cacNumber: state.userReducer.cacNumber,
    locations: state.locationReducer.locations,
    states: state.locationReducer.states,
    countries: state.locationReducer.countries,
    companyId: state.userReducer.companyId,
    customer: state.userReducer.customer,
    locationTypes: state.locationReducer.locationTypes,
    userLocations: state.locationReducer.userLocations,
    companyLocations: state.locationReducer.companyLocations,
  };
  console.log(state.locationReducer.locations);
}
const mapDispatchToProps = (dispatch) => ({
  UpdateLocation(payload) {
    dispatch({ type: "UPDATE_LOCATION", payload });
  },

  LoadCustomerInfo(payload) {
    dispatch({ type: "LOAD_CUSTOMER_INFO", payload });
  },
  AddCustomerInfo(payload) {
    dispatch({ type: "ADD_CUSTOMER_INFO", payload });
  },

  ApproveCustomerCredit(payload) {
    dispatch({ type: "APPROVE_CUSTOMER", payload });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Locations);
